import { ShimmerLoadingBar } from '@/ui-library/components/atoms/ShimmerLoadingBar/ShimmerLoadingBar';
import { KText } from '@/ui-library/components';
import { Flex, Icon } from '@chakra-ui/react';
import { AiScoringConstants } from '../aiScoringConstants';
import { StepConfig, StepLoader } from '@kula-ai/components';
import { Stars03 } from '@kula-ai/icons-core';

export const AiScoringLoader = ({
  isStep = true,
  config = AiScoringConstants.loaderSteps.icp,

  message = 'Analyzing job description...',
}: {
  message?: string;
  isStep?: boolean;
  config?: {
    steps: StepConfig[];
    message: {
      title: string;
      description: string;
    };
  };
}) => {
  if (isStep) {
    return (
      <Flex
        flexDirection="column"
        gap="24px"
        alignItems="center"
        justifyContent="center"
        h="100%"
        w="100%"
        mt="-15%"
        maxW="375px"
      >
        <Flex flexDirection="column" gap="8px">
          <Flex gap="8px" alignItems="center">
            <Stars03
              strokeWidth="1.2"
              gradient={{
                direction: 'vertical',
                colors: [
                  { offset: '0%', color: '#797DFF' },
                  { offset: '100%', color: '#680AF5' },
                ],
              }}
            />
            <KText variant="heading_1">{config.message.title}</KText>
          </Flex>
          {config.message.description && (
            <KText>{config.message.description}</KText>
          )}
        </Flex>
        <StepLoader steps={config.steps} />
      </Flex>
    );
  }

  return (
    <Flex flexDirection="column" gap="24px" alignItems="center" mt="-15%">
      <Flex gap="8px" alignItems="center">
        <Icon as={Stars03} color="#B15FDA" />
        <KText
          sx={{
            ...AiScoringConstants.gradientStyle,
          }}
        >
          {message}
        </KText>
      </Flex>

      <Flex flexDirection="column" gap="20px" w="335px">
        <ShimmerLoadingBar w="100%" />
        <ShimmerLoadingBar w="80%" />
        <ShimmerLoadingBar w="100%" />
        <ShimmerLoadingBar w="80%" />
      </Flex>
    </Flex>
  );
};
